import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { useAuth } from "../hooks/AuthProvider";
import { Toast } from 'primereact/toast';
import { SplitButton } from 'primereact/splitbutton';
import { useKeycloak } from "@react-keycloak/web";


function UserIcon({ isLoggedIn }) {
    const auth = useAuth();
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const backgroundColor = storedUser ? '#2196F3' : '#E5E7EB';
    const foregroundColor = storedUser ? '#FFFFFF' : '#3C3C3C';
    const loggedinColor = storedUser ? 'info' : 'info';
    const splitButtonType = true;
    const toast = useRef(null);
    const { keycloak } = useKeycloak();

    const items = [
        {
            label: 'Log out',
            icon: 'pi pi-sign-out',
            command: () => {
                keycloak.logout();
            }
        }
    ];


    const handleLogOut = () => {
        auth.logOut();
    };

    return (
        <>
                <Toast ref={toast}></Toast>
                {<SplitButton text label={keycloak.tokenParsed?.preferred_username} icon="pi pi-user" model={items} severity={loggedinColor} />}
        </ >
    );
}

export default UserIcon;